


























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button, CellGroup } from 'vant';
import SearchInput from '@/components/SearchInput.vue';
import { getBaseInfo } from '../api/index';
import { voteList } from '../api/index';
import { Tab, Tabs } from 'vant';
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Button);
@Component({
  components: {
    SearchInput,
  },
})
export default class VoteList extends Vue {
  @Prop() options!: any;
  loading = false;
  finished = false;
  ifvote = false;
  baseInfo: any = {};
  votetime: any = '';
  nowtime: any = '';
  active = 0;
  page = 1;
  getListData: any[] = [];
  result = [];
  SearchData = '';
  ListType = 1;
  @Watch('ListType')
  onListTypeChanged(newVal: any, val: any) {
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.getListData = [];
    setTimeout(() => {
      this.onLoad();
    }, 1000);
  }


  // 初使加载
  onLoad() {
    setTimeout(() => {
      voteList(this.page, this.ListType, this.SearchData).then(
        (res: any) => this.fetchListData(res),
      );
      (this.$refs.input as any).ChangeDisplay();
    });
    getBaseInfo().then((res: any) => {
      this.baseInfo = res.data;
    });
    this.getTime();
  }
  fetchListData(res: any) {
    if (res.code === 100) {
      this.finished = true;
    } else {
      this.finished = false;
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    this.$router.push({ path: './Detail', query: { id: item.id, source: item.awards } });
  }
  // 多选
  chooseOpus() {
    // bus.$emit('testF', this.result);
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch() {
      this.getListData = [];
      this.page = 1;
      this.finished = false;
      setTimeout(() => {
        this.onLoad();
      }, 500);
  }
  searchNewsData(res: any) {
    this.getListData = [...res.data];
    this.finished = true;
  }

  onChange(e: any) {
    if (e === 0) {
      this.ListType = 1;
    } else {
      this.ListType = 2;
    }
  }
  getTime() {
    setInterval( () => {
      this.nowtime = new Date();
      this.nowtime = Date.parse(this.nowtime) / 1000;
      this.votetime = this.baseInfo.startTime;
      if (this.nowtime > this.votetime) {
        this.ifvote = true;
      } else {
        this.ifvote = false;
      }
    }, 1000);
  }
}
